import { css } from "../helpers/webComponents";
import { TimerService } from "../services/TimerService";

const styles: string = css`
    div {
        position: absolute;
        z-index: 9999;
        background-color: #2e3945;
        border-radius: 5px;
        padding: 3px;
        left: 10px;
    }
`;

//
export class TimerComponent extends HTMLElement {
    private readonly _timerService = new TimerService();
    private _intervalId: number | undefined;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.startTimerLoop();
        void this.render();
    }

    public disconnectedCallback(): void {
        if (this._intervalId !== undefined) {
            clearInterval(this._intervalId);
        }
    }

    private startTimerLoop(): void {
        void this.render();
        this._intervalId = window.setInterval(() => {
            void this.render();
        }, 1000);
    }

    private async render(): Promise<void> {
        const shadow: ShadowRoot | null = this.shadowRoot;
        if (!shadow) return;

        try {
            const { expired, remainingSeconds } = await this._timerService.getRemainingTime();

            if (remainingSeconds === 0 && !expired) {
                return;
            }

            if (expired) {
                shadow.innerHTML = "<div>💀 Time has expired</div>";

                setTimeout(() => {
                    window.location.reload();
                    clearInterval(this._intervalId);
                }, 1500);

                clearInterval(this._intervalId);
                return;
            }

            const mins: number = Math.floor(remainingSeconds / 60);
            const secs: number = remainingSeconds % 60;
            shadow.innerHTML = `<div>⏱️ ${mins}:${secs < 10 ? "0" + String(secs) : String(secs)}</div>`;

            if (!shadow.querySelector("style")) {
                const styleElem: HTMLStyleElement = document.createElement("style");
                styleElem.textContent = styles;
                shadow.appendChild(styleElem);
            }
        }
        catch (error) {
            console.error("TimerComponent error:", error);
        }
    }
}
